import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpParams } from '@angular/common/http';

import { CartPrice } from '../../../../projects/shared-lib/src/lib/models/cart-price';
import { Parking } from '../../../../projects/shared-lib/src/lib/models/parking';
import { CartService } from '../../../../projects/shared-lib/src/lib/services/cart.service';
import { Cart } from '../../../../projects/shared-lib/src/lib/models/cart';
import { Page } from '../../../../projects/shared-lib/src/lib/models/page';

import { PriceWeb } from '../../../../projects/shared-lib/src/lib/models/price-web';
import { AnalyticsService } from '../../shared/services/analytics.service';
import { PerformanceResponseLight } from '../../../../projects/shared-lib/src/lib/models/performance-response-light';
import { PriceLevels } from '../../../../projects/shared-lib/src/lib/models/price-levels';
import { TrackerPrice } from '../../../../projects/shared-lib/src/lib/models/tracker-price';

import { cloneObjectHelps } from '../../../../projects/shared-lib/src/lib/services';
import { SeatsSelected } from '../../../../projects/shared-lib/src/lib/models/seats-selected';

export interface TotalPrices {
    total: number;
    qty: number;
}
export interface FirstItems {
    codePrice: string;
    qty: number;
    price?: CartPrice;
}
export interface SelectSamePriceForAllItems {
    nbItem: number;
    firstItems?: FirstItems[];
}

@Injectable({
    providedIn: 'root',
})
export class PriceManagerService {
    priceSelected: PriceWeb[] = [];
    totalSameNbTicketForAllItems = 0;
    private subjectTotal = new Subject<TotalPrices>();
    private subjectPriceSelection = new Subject<any>();

    selectSamePriceForAllItems = new BehaviorSubject<SelectSamePriceForAllItems>(null);

    constructor(
        private cartService: CartService,
        private analyticsService: AnalyticsService,
    ) {}

    watchTotal(): Observable<TotalPrices> {
        return this.subjectTotal.asObservable();
    }

    watchPriceSelection(): Observable<any> {
        return this.subjectPriceSelection.asObservable();
    }

    setPricesSelect(val: PriceWeb[]) {
        this.priceSelected = val;
    }
    addSubjectPriceSelection(val: any) {
        const clonedVal = cloneObjectHelps(val);
        this.subjectPriceSelection.next(clonedVal);
    }

    qtyMinusOne(price: CartPrice): number {
        if (price.cartDetailToken) {
            price.qty = price.cartDetailToken.length;
        }
        let futureQty = 0;
        if (price.divisor && price.divisor > 0) {
            futureQty = price.qty - price.divisor;
        } else {
            futureQty = price.qty - 1;
        }

        price.qty = futureQty;

        if (price.qty < price.minTickets) {
            price.qty = 0;
        }
        if (price.minTickets <= price.qty || price.qty === 0) {
            price.total = (price.serviceCharges + price.price) * price.qty;
        }

        this.deleteAllQTYPriceEqualZero();
        this.removePrice(price);
        this.getTotalForAllPrice();
        return price.qty;
    }

    qtyPlusOne(price: CartPrice | PriceWeb): number {
        /**
         * const va = this.gePriceByCart();
         if (va && va.cartDetailToken) {
            price.qty = va.cartDetailToken.length;
        }
         */
        if (!price.qty) {
            price.qty = 0;
        }
        let futureQty = 0;
        if (price.divisor && price.divisor > 0) {
            futureQty = price.qty + price.divisor;
        } else {
            futureQty = price.qty + 1;
        }

        if (futureQty >= 0 && (futureQty <= price.maxTickets || price.maxTickets === 0)) {
            price.qty = futureQty;
            if (price.qty === 1 && price.minTickets > 0) {
                price.qty = price.minTickets;
            }
            if (price.minTickets <= price.qty) {
                price.total = (price.serviceCharges + price.price) * price.qty;
            }
        }
        //console.log('price:', price);
        this.addPrice(price);
        this.getTotalForAllPrice();
        this.analyticsService.trackItemSelection([<any>price]);
        return price.qty;
    }

    getFutureQtyPlusOne(price) {
        let futureQty = price?.qty || 0;
        if (price.divisor && price.divisor > 0) {
            futureQty = price.qty + price.divisor;
        } else {
            futureQty = price.qty + 1;
        }
        if (price.maxTickets && futureQty > price.maxTickets) {
            futureQty = price.maxTickets;
        }
        if (futureQty >= 0 && (futureQty <= price.maxTickets || price.maxTickets === 0)) {
            if (futureQty === 1 && price.minTickets > 0) {
                futureQty = price.minTickets;
            }
        }
        return futureQty;
    }
    getFutureQtyMinusOne(price) {
        let futureQty = price?.qty || 0;
        if (price.divisor && price.divisor > 0) {
            futureQty = price.qty - price.divisor;
        } else {
            futureQty = price.qty - 1;
        }
        if (futureQty < price.minTickets) {
            futureQty = 0;
        }
        return futureQty;
    }

    clearPricesSelected() {
        this.priceSelected = [];
        this.addSubjectPriceSelection([]);
        this.getTotalForAllPrice();
    }

    getPricesSelected(): CartPrice[] {
        return cloneObjectHelps(this.priceSelected.filter((val) => !!val));
    }

    getEventsHttpParams(httpParams?: HttpParams): HttpParams {
        if (!httpParams) {
            httpParams = new HttpParams();
        }
        const temp = this.priceSelected.map((item) => item.eventId).filter((value, index, self) => self.indexOf(value) === index);
        if (temp.length === 0) {
            return httpParams;
        }
        httpParams = httpParams.set('events', temp.join(','));
        return httpParams;
    }

    addValidPrice(price: PriceWeb, priceLevels: PriceLevels[]) {
        this.addValidPriceWithoutObserver(price, priceLevels);
        this.addPrice(price);
        this.getTotalForAllPrice();
    }
    validateMaxTickets(price: PriceWeb, priceLevels: PriceLevels[]): boolean {
        if (!price || !priceLevels || priceLevels.length === 0) {
            return true;
        }

        for (const priceLevel of priceLevels) {
            if (priceLevel.prices && priceLevel.prices.length > 0) {
                const targetPrice = priceLevel.prices.find((p) => p.id === price.id);
                if (targetPrice) {
                    const firstMaxTickets = priceLevel.prices[0]?.maxTickets;

                    return priceLevel.prices.every((p) => p.maxTickets === firstMaxTickets);
                }
            }
        }

        return true;
    }

    addValidPriceWithoutObserver(price: PriceWeb, priceLevels: PriceLevels[] = []) {
        const futureQty = price.qty;
        const validateMaxTickets = this.validateMaxTickets(price, priceLevels);
        if (futureQty >= 0 && (futureQty <= price.maxTickets || price.maxTickets === 0 || !validateMaxTickets)) {
            price.qty = futureQty;
            if (price.qty === 1 && price.minTickets > 0) {
                price.qty = price.minTickets;
            }
            if (price.minTickets <= price.qty) {
                price.total = (price.serviceCharges + price.price) * price.qty;
            }
        } else {
            // this.seatService.subSeatSelectedToRemoveLast.next(new Date().getTime());
            throw new Error('invalid qty =' + price.qty + ' Min Tickets =' + price.minTickets + ' Max Tickets = ' + price.maxTickets);
        }
    }

    addPrice(price: PriceWeb) {
        //console.log(price);
        //console.log(this.priceSelected);
        this.addPriceWithoutObserver(price);
        this.addSubjectPriceSelection(this.priceSelected);

        //console.log(this.priceSelected)
        // console.log('###############################')
    }
    addPriceWithoutObserver(price: PriceWeb) {
        this.priceSelected = this.priceSelected.filter((val) => !this.hasSamePrice(val, price) && val.qty > 0);
        if (price.qty > 0) {
            price.total = ((price.price ? price.price : 0) + (price?.serviceCharges || 0)) * price.qty;
            this.priceSelected.push(price);
        }
    }
    addPricesWithoutObserver(prices: PriceWeb[]) {
        this.priceSelected = this.priceSelected.filter((val) => !prices.some((price) => this.hasSamePrice(val, price)) && val.qty > 0);
        prices.forEach((price) => {
            if (price.qty > 0) {
                price.total = ((price.price ? price.price : 0) + (price?.serviceCharges || 0)) * price.qty;
                this.priceSelected.push(price);
            } else {
                price.total = 0;
            }
        });
    }

    addPrices(prices: PriceWeb[]) {
        this.addPricesWithoutObserver(prices);
        this.addSubjectPriceSelection(this.priceSelected);
    }

    removePrice(price: PriceWeb, removeParking = true) {
        this.removePriceWithoutObserver(price, removeParking);
        this.addSubjectPriceSelection(this.priceSelected);
    }
    removePriceWithoutObserver(price: PriceWeb, removeParking = true) {
        this.priceSelected = this.priceSelected.filter((val) => !this.hasSamePrice(val, price) && val.qty > 0);
        if (removeParking) {
            this.priceSelected = this.priceSelected.filter((val) => !(price.eventId === val.eventId && val.parkingId && price.qty <= 0));
        }

        if (price.qty > 0) {
            this.priceSelected.push(price);
        }
    }

    addPriceParking(priceParking: Parking, date: any, qty: number) {
        const temp = <PriceWeb>{
            subscriptionId: null,
            byocId: null,
            eventId: priceParking.eventId,
            price: priceParking.amount,
            parkingId: priceParking.id,
            parkingDate: date,
            parkingType: priceParking.type,
            qty: qty,
            total: priceParking.amount * qty,
        };
        this.priceSelected = this.priceSelected.filter((val) => !this.hasSamePrice(val, temp) && val.qty > 0);
        this.priceSelected.push(temp);
        //console.log('priceslected', this.priceSelected);
        // The parking is tracked when displayed
        this.deleteAllQTYPriceEqualZero();
    }

    hasSamePrice(val: PriceWeb, val2: PriceWeb): boolean {
        const keys = [
            'eventId',
            'id',
            'subscriptionId',
            'hoursId',
            'comboId',
            'parkingId',
            'parkingDate',
            'byocId',
            'giftCertificatesId',
            'comboGroupId',
        ];
        if (val.hoursId === 0) {
            val.hoursId = null;
        }
        if (val2.hoursId === 0) {
            val2.hoursId = null;
        }
        const comparisons = keys.reduce(
            (acc, k) => {
                const a = (val as any)[k];
                const b = (val2 as any)[k];
                acc[k] = { a, b, equal: a === b };
                return acc;
            },
            {} as Record<string, { a: any; b: any; equal: boolean }>,
        );
        console.log('compare:', comparisons);
        return keys.every((k) => (val as any)[k] === (val2 as any)[k]);
    }

    deleteAllQTYPriceEqualZero() {
        this.priceSelected = this.priceSelected.filter((val) => val.qty > 0);
    }

    doSinglePricesInPriceLevelConfirmed() {
        this.priceSelected = this.priceSelected.filter((val) => val.qty > 0);
    }

    getTotalForAllPrice() {
        const temp = this.getDetailReserved();
        this.subjectTotal.next({
            total: temp.total,
            qty: temp.qty,
        });
    }
    getDetailReserved(): { total: number; qty: number; prices: PriceWeb[] } {
        let total = 0;
        let qty = 0;
        this.priceSelected.forEach((p) => {
            if (p) {
                total = total + p.qty * (p.price + (p.serviceCharges ? p.serviceCharges : 0));
                qty = qty + p.qty;
            }
        });
        const temp = <TotalPrices>{
            qty: qty,
            total: total,
        };
        return { ...temp, prices: this.priceSelected };
    }

    updatePriceSeats(val: PriceWeb, seatIds: any[]) {
        this.priceSelected.forEach((value) => {
            if (value.id === val.id) {
                value.seatIds = seatIds;
            }
        });
    }

    /**
     * pour subscription stfx university
     * ***/
    isValidToSamePriceForAllItems(page: Page) {
        this.totalSameNbTicketForAllItems = 0;
        const c = <Cart>this.cartService.cartSub.value;
        if (!page || !page.subscriptions || page.subscriptions.length === 0 || !c || c.cartElements.length === 0) {
            return false;
        }
        const m = [];
        c.cartElements.forEach((value) => {
            if (value._type === 'subscription' && this.isValidSubscriptions(value.id, page)) {
                value.prices.forEach((price) => {
                    const id = String(price.subscriptionId) + 'tag';
                    price.qty = price.cartDetailToken.length;
                    if (!m[id]) {
                        m[id] = [];
                        m[id].push(price);
                    } else {
                        m[id].push(price);
                    }
                });
            }
        });
        //console.log(m);
        Object.keys(m)?.forEach((value) => {
            const prices = m[value];
            prices.forEach((p) => {
                this.totalSameNbTicketForAllItems = this.totalSameNbTicketForAllItems + p.qty * (p.price + p.serviceCharges);
            });
        });
        console.log(this.totalSameNbTicketForAllItems);
        const firstItems = [];
        c.cartElements.forEach((value) => {
            if (value._type === 'subscription' && this.isValidSubscriptions(value.id, page)) {
                value.prices.forEach((pc) => {
                    if (pc.subscriptionId === page.subscriptions[0].id) {
                        firstItems.push({
                            codePrice: this.getUniqueName(pc),
                            qty: pc.cartDetailToken.length,
                        });
                    }
                });
            }
        });

        //console.log(Object.keys(m).length);

        if (page.subscriptions.length !== Object.keys(m).length) {
            return false;
        }
        let valid = true;

        Object.keys(m).forEach((value) => {
            const priceWebs = m[value];
            if (priceWebs.length !== firstItems.length) {
                valid = false;
            }
            priceWebs.forEach((p) => {
                if (!firstItems.find((pc) => pc.codePrice === this.getUniqueName(p) && p.qty === pc.qty)) {
                    valid = false;
                }
            });
        });
        return valid;
    }

    isValidSubscriptions(id, page: Page) {
        if (!page.subscriptions) {
            return false;
        }
        return page.subscriptions.find((val) => val.id === id) !== undefined;
    }

    getUniqueName(p: PriceWeb | CartPrice) {
        return p.priceLevel + p.priceType;
    }

    /**
     *  * Format the price for abandoned cart
     * @param price
     * @param performanceResponseLight
     * @param imageUrlBig
     * @param urlPage
     */

    formatPriceAbandonedCart(
        price: PriceWeb,
        performanceResponseLight: PerformanceResponseLight,
        imageUrlBig: string,
        urlPage = window.location.href,
    ) {
        price.pageUrl = urlPage;
        price.venue = performanceResponseLight.venue;
        price.title = performanceResponseLight.title;

        if (imageUrlBig) {
            price.imageUrl = imageUrlBig;
        }

        if (performanceResponseLight?.images && performanceResponseLight?.images?.length > 0) {
            price.imageUrl = performanceResponseLight?.images[0]?.url;
        }

        if (performanceResponseLight?.images && performanceResponseLight.images.length > 0) {
            price.imageUrl = performanceResponseLight?.images[0]?.url;
        }

        if (performanceResponseLight?.itemHours && performanceResponseLight?.itemHours.length === 1) {
            price.date = performanceResponseLight.itemHours[0].formattedDate;
        }
    }

    filterPriceWebByPriceLevelId(priceLevelId: number): PriceWeb[] {
        return this.priceSelected.filter((p) => p.priceLevelId === priceLevelId && p.qty > 0);
    }
    clearBySeatIds(sSelected: SeatsSelected[]) {
        if (!sSelected || sSelected.length === 0) {
            this.priceSelected = [];
            this.getTotalForAllPrice();
            return;
        }
        const seatsIds = sSelected.map((s) => s.seatIds);
        this.priceSelected.forEach((p) => {
            p.seatIds = p.seatIds.filter((s) => seatsIds.includes(s));
            p.qty = p.seatIds.length;
            p.total = p.qty * (p.price + (p.serviceCharges ? p.serviceCharges : 0));
        });
        this.setPricesSelect(this.priceSelected.filter((p) => p.qty > 0));
        this.getTotalForAllPrice();
    }
    isDeleteSeats(sSelected: SeatsSelected[]) {
        if (!sSelected || sSelected.length === 0) {
            return true;
        }
        const seatIds = sSelected.map((s) => s.seatIds).flat();
        const seatInPrice = this.priceSelected?.map((p) => p.seatIds).flat();
        if (!seatInPrice || seatInPrice.length === 0) {
            return false;
        }
        return seatInPrice.length > seatIds.length;
    }
}
